import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { AuthService } from "../services/auth.service";

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    router.navigate(["/auth/login"]);
    return false;
  }

  if (!authService.hasBackofficeAccess()) {
    authService.logout({ reason: "unauthorized" });
    return false;
  }

  return true;
};
